export class TaskDisplayGroup {
	constructor() {
	}
} 
